/**
 * Feb-2026 (User-Wunsch) — Dezentes Muster-ZB1 als Hintergrund-Wasserzeichen in
 * der Upload-Dropzone. Stilisierte „Zulassungsbescheinigung Teil I" (kein echtes
 * Dokument) — soll dem Händler signalisieren, dass hier u. a. die ZB1 reingezogen
 * werden kann. Bewusst sehr blass (opacity) gehalten, damit der Text lesbar bleibt.
 */
export default function Zb1Watermark({ className = "" }) {
    return (
        <svg
            viewBox="0 0 320 200"
            className={className}
            preserveAspectRatio="xMidYMid meet"
            aria-hidden="true"
            focusable="false"
        >
            {/* Dokument-Korpus (typisch grünlich-graue ZB1) */}
            <rect x="8" y="10" width="304" height="180" rx="8" fill="#e9f1e8" stroke="#9cb89c" strokeWidth="2" />
            {/* feine Guilloché-Andeutung */}
            <g stroke="#bcd2bc" strokeWidth="1" opacity="0.6">
                <line x1="8" y1="150" x2="312" y2="120" />
                <line x1="8" y1="165" x2="312" y2="135" />
                <line x1="8" y1="180" x2="312" y2="150" />
            </g>
            {/* Kopfzeile */}
            <rect x="8" y="10" width="304" height="30" rx="8" fill="#6f8f6f" />
            <rect x="8" y="32" width="304" height="8" fill="#6f8f6f" />
            <text x="20" y="30" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="700" fill="#ffffff" letterSpacing="0.5">
                ZULASSUNGSBESCHEINIGUNG TEIL I
            </text>
            {/* EU-Sterne-Kreis-Andeutung */}
            <circle cx="290" cy="25" r="9" fill="none" stroke="#ffffff" strokeWidth="1.2" />
            <text x="290" y="29" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="700" fill="#ffffff">D</text>

            {/* Feld-Raster mit Codes (A, B, D.1 …) */}
            <g fontFamily="Arial, sans-serif" fill="#5d735d">
                {/* Zeile 1 */}
                <rect x="20" y="54" width="130" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="25" y="64" fontSize="7" fontWeight="700">A</text>
                <line x1="25" y1="74" x2="140" y2="74" stroke="#cdddcd" strokeWidth="3" />

                <rect x="160" y="54" width="140" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="165" y="64" fontSize="7" fontWeight="700">B</text>
                <line x1="165" y1="74" x2="290" y2="74" stroke="#cdddcd" strokeWidth="3" />

                {/* Zeile 2 */}
                <rect x="20" y="88" width="86" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="25" y="98" fontSize="7" fontWeight="700">D.1</text>
                <line x1="25" y1="108" x2="98" y2="108" stroke="#cdddcd" strokeWidth="3" />

                <rect x="116" y="88" width="86" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="121" y="98" fontSize="7" fontWeight="700">D.2</text>
                <line x1="121" y1="108" x2="194" y2="108" stroke="#cdddcd" strokeWidth="3" />

                <rect x="212" y="88" width="88" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="217" y="98" fontSize="7" fontWeight="700">D.3</text>
                <line x1="217" y1="108" x2="292" y2="108" stroke="#cdddcd" strokeWidth="3" />

                {/* Zeile 3 */}
                <rect x="20" y="122" width="86" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="25" y="132" fontSize="7" fontWeight="700">P.1</text>
                <line x1="25" y1="142" x2="98" y2="142" stroke="#cdddcd" strokeWidth="3" />

                <rect x="116" y="122" width="86" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="121" y="132" fontSize="7" fontWeight="700">P.2</text>
                <line x1="121" y1="142" x2="194" y2="142" stroke="#cdddcd" strokeWidth="3" />

                <rect x="212" y="122" width="88" height="26" rx="3" fill="#ffffff" stroke="#a9c1a9" />
                <text x="217" y="132" fontSize="7" fontWeight="700">2.1</text>
                <line x1="217" y1="142" x2="292" y2="142" stroke="#cdddcd" strokeWidth="3" />
            </g>
        </svg>
    );
}
